import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { AppSettings } from '../app-settings';

export function initSentry({ sentryConfig }: AppSettings) {
  if (sentryConfig.enabled) {
    const conf: Sentry.BrowserOptions = {
      dsn: sentryConfig.dsn,
      integrations: [new Integrations.BrowserTracing()],
      release: sentryConfig.release,
      environment: sentryConfig.env,
      autoSessionTracking: true,
      debug: false,
    };

    Sentry.init(conf);
  }
}
